import React, { createContext, useContext, useEffect, useState } from 'react';

// Create a new Payment context
const AddressContext = createContext(null);

// Create a custom hook to use the context
export function useAddress() {
    return useContext(AddressContext);
}
type AccordionStateType = {
    id: number;
    isOpen: boolean;
};

// Create a context provider component
export function AddressProvider({ children }) {
    const [mode, setMode] = useState('view');
    const [mode2, setMode2] = useState('view');
    const [showNotification, setShowNotification] = useState(false);
    const [showWarning, setShowWarning] = useState(false);
    const [accordionStates, setAccordionStates] = useState<AccordionStateType[]>([
        { id: 0, isOpen: true },
        { id: 1, isOpen: false },
        { id: 2, isOpen: false },
    ]);

    const handleAccordionStateChange = (accordionId: number, newIsOpen: boolean) => {
        if (newIsOpen) {
            const updatedStates = accordionStates.map((accordion) => ({
                ...accordion,
                isOpen: accordion.id === accordionId,
            }));
            setAccordionStates(updatedStates);
        } else {
            setAccordionStates((prevAccordionStates) => {
                const updatedStates = [...prevAccordionStates];
                const index = updatedStates.findIndex((accordion) => accordion.id === accordionId);

                if (index !== -1) {
                    updatedStates[index].isOpen = newIsOpen;
                }

                return updatedStates;
            });
        }
    };

    function updateAccordionAtIndex(index, isOpen) {
        if (index >= 0 && index < accordionStates.length) {
            const updatedAccordionState = [...accordionStates];
            updatedAccordionState[index].isOpen = isOpen;
            setAccordionStates(updatedAccordionState);
        } else {
            console.log('Invalid index.');
        }
    }

    function toggleAccordionAtIndex(index) {
        if (index >= 0 && index < accordionStates.length) {
            const updatedAccordionState = [...accordionStates];
            updatedAccordionState[index].isOpen = !updatedAccordionState[index].isOpen;
            setAccordionStates(updatedAccordionState);
        } else {
            console.log('Invalid index.');
        }
    }

    // Value object to be provided to consuming components
    const value = {
        mode,
        mode2,
        setMode,
        setMode2,
        accordionStates,
        setAccordionStates,
        handleAccordionStateChange,
        updateAccordionAtIndex,
        toggleAccordionAtIndex,
        showNotification,
        setShowNotification,
        showWarning,
        setShowWarning,
    };

    return <AddressContext.Provider value={value}>{children}</AddressContext.Provider>;
}
